import { Component, OnInit } from '@angular/core';
import { PodcastService } from 'src/app/services/podcast.service';
import { PlayerService } from 'src/app/services/player.service';
import { Podcast } from 'src/models/podcast';
import { Stream } from 'src/models/stream';
import { InfiniteScrollableComponent } from '../../base/infinite-scrollable/infinite-scrollable.component';

@Component({
  selector: 'app-top-podcasts',
  templateUrl: './top-podcasts.component.html',
  styleUrls: ['./top-podcasts.component.scss']
})
export class TopPodcastsComponent extends InfiniteScrollableComponent implements OnInit {

  public streams = new Array<Stream>();

  private itemsPerPage = 20;

  public topStations = new Array<Stream>();

  public scrollControlEnabled = false;

  constructor(
    private podcastService: PodcastService,
    private playerService: PlayerService) {
    super();
  }

  ngOnInit() {
    this.streams = new Array<Stream>();
    this.start = 0;

    this.loadStreams();
  }

  protected getItemsPerPage(): number {
    return this.itemsPerPage;
  }

  protected loadStreams() {
    this.scrollControlEnabled = false;

    const page = (this.start / this.itemsPerPage) + 1;

    this.podcastService.getTopGermanPodcasts(page).subscribe((value: Stream[]) => {
      value.forEach((stream: Stream) => this.streams.push(stream));

      if (value.length === this.itemsPerPage) {
        this.scrollControlEnabled = true;
      }
    });
  }

  public onPlayStreamClicked(stream: Stream) {
    this.playerService.setCurrentStream(stream);
  }

}
